import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import translations from "../constants/translations";
import { setLanguage } from "../reducers/userConfigSlice";

/**
 * Keeps the "literals" (translations) in sync with the active language.
 *
 * Important: this must NOT dispatch on every render; it should only dispatch
 * when the language changes.
 */
export default function useLanguage() {
  const dispatch = useDispatch();
  const activeLang = useSelector((state) => state.aplicationConfig.userConfig.language);

  useEffect(() => {
    const next = activeLang === "es" ? translations.es : translations.en;
    dispatch(setLanguage(next));
  }, [activeLang, dispatch]);
}
